import { render, staticRenderFns } from "./m-subscription.vue?vue&type=template&id=48f0924d&scoped=true"
import script from "./m-subscription.vue?vue&type=script&lang=js"
export * from "./m-subscription.vue?vue&type=script&lang=js"
import style0 from "./m-subscription.vue?vue&type=style&index=0&id=48f0924d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f0924d",
  null
  
)

export default component.exports